import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  moduleList: [],
  roleList: [],
  roleDetail: [],
  loading: false,
  error: undefined,
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchRoleList(state, action) {
      state.roleList = action.payload;
      state.loading = false;
    },
    fetchRoleDetail(state, action) {
      state.roleDetail = action.payload;
      state.loading = false;
    },
    fetchMenuList(state, action) {
      state.moduleList = action.payload;
      state.loading = false;
    },
  },
});

export const roleActions = roleSlice.actions;

export default roleSlice.reducer;
